// @ts-nocheck
import React, { PropsWithChildren } from 'react';
import styled from 'styled-components';

import { TabStyled } from './Tab.style';
import { useTabsContext } from './Tabs.context';

const TabContent = styled.div`
  flex-basis: 100%;
`;

export type TabProps = {
  icon: string;
  id: string;
  title: string;
};

function Tab({ children, icon, id, title }: PropsWithChildren<TabProps>) {
  const { activeTabId, setActiveTab } = useTabsContext();
  const isSelected = activeTabId === id;
  const onTabClick = () => setActiveTab(id);

  return (
    <>
      <TabStyled isSelected={isSelected} onClick={onTabClick}>
        <i className={icon} />
        <div>{title}</div>
      </TabStyled>
      {isSelected && <TabContent>{children}</TabContent>}
    </>
  );
}

export default Tab;
